import React from 'react';

const Bell: React.FC = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        cursor: 'pointer',
      }}
    >
      <path
        d="M26.7298 21.9644C25.1248 20 23.9917 19 23.9917 13.5844C23.9917 8.625 21.4592 6.85812 19.3748 6C19.0979 5.88625 18.8373 5.625 18.7529 5.34062C18.3873 4.09625 17.3623 3 15.9998 3C14.6373 3 13.6117 4.09688 13.2498 5.34188C13.1654 5.62938 12.9048 5.88625 12.6279 6C10.5411 6.85938 8.01107 8.62 8.01107 13.5844C8.00795 19 6.87482 20 5.26982 21.9644C4.60482 22.7781 5.18732 24 6.35045 24H25.6554C26.8123 24 27.3911 22.7744 26.7298 21.9644Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 24V25C20 26.0609 19.5786 27.0783 18.8284 27.8284C18.0783 28.5786 17.0609 29 16 29C14.9391 29 13.9217 28.5786 13.1716 27.8284C12.4214 27.0783 12 26.0609 12 25V24"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Bell;
